import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';

export const HubContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

// 320px content block, centralizado, com gap-32px entre seção 1 e 2
export const ContentBlock = styled(Box)(({ theme }) => ({
  width: '100%',
  // maxWidth: 320,
  // margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4) // 32px
}));

// Seção 1 – dois cards de categoria lado a lado
export const CategoryCardsRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: 40
}));

export const CategoryCard = styled(ButtonBase)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 4,
  padding: 0
}));

export const CategoryCardIcon = styled(Box)(({ theme }) => ({
  width: 80,
  height: 80,
  borderRadius: 8,
  backgroundColor: theme.palette.neutrals.beige2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    width: 32,
    height: 32,
    color: theme.palette.brand.darkGreen
  }
}));

/**
 * @todo adicionar body3R no design sistem
 */
export const CategoryCardLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.neutrals.lead,
  whiteSpace: 'nowrap'
}));

// Seção 2 – arquivos mais recentes
export const RecentSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5) // 12px
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1B,
  color: theme.palette.neutrals.lead
}));

export const FileItemRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(1), // 8px
  paddingBottom: theme.spacing(1), // 8px
  width: '100%'
}));

export const FileItemInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5), // 4px
  flex: 1,
  minWidth: 0,
  overflow: 'hidden'
}));

export const FileItemName = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.neutrals.lead,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const FileItemDate = styled(Typography)(({ theme }) => ({
  ...theme.typography.body3,
  color: theme.palette.neutrals.lead
}));

export const FileItemActions = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  flexShrink: 0
}));

// "ver mais" centralizado
export const ViewMoreButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center'
}));

// Seção 3 – lista de categorias (320px centralizado)
export const CategoryListSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const EmptyStateText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.neutrals.beige4,
  textAlign: 'center',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}));
